<button class="_common-button--rounded"
        mat-flat-button color="primary"
        (click)="openEmailContent()">View</button>
